import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { LogIn, ArrowLeft, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // If already authenticated, go straight to the dashboard.
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(() => navigate("/admin"))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-[#0a0b0a] grain flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
        data-testid="login-card"
      >
        <a
          href="/"
          data-testid="login-back-home"
          className="inline-flex items-center gap-2 text-sm text-[#9ca399] hover:text-[#eae7e0] transition-colors mb-12"
        >
          <ArrowLeft size={16} /> Back to site
        </a>

        <p className="text-[11px] tracking-[0.28em] uppercase text-[#b89b72] mb-5">
          MRS Builders · Admin
        </p>
        <h1 className="font-display font-light text-[#eae7e0] text-4xl md:text-5xl tracking-tight leading-[1.05] mb-4">
          Welcome back.
        </h1>
        <p className="text-[#9ca399] leading-relaxed mb-10">
          Sign in to review the enquiries submitted through your website.
        </p>

        {checking ? (
          <div className="flex items-center gap-3 text-[#9ca399]">
            <Loader2 size={18} className="animate-spin text-[#b89b72]" /> Checking session…
          </div>
        ) : (
          <button
            onClick={handleGoogleLogin}
            data-testid="google-login-button"
            className="group w-full flex items-center justify-center gap-3 px-8 py-4 bg-[#b89b72] text-[#0a0b0a] text-[12px] tracking-[0.2em] uppercase hover:bg-[#cbb38e] transition-colors duration-300"
          >
            <LogIn size={18} />
            Continue with Google
          </button>
        )}

        <p className="mt-8 text-xs text-[#9ca399]/70 leading-relaxed">
          Access is restricted to authorised MRS Builders accounts.
        </p>
      </motion.div>
    </div>
  );
}
